import createIcon from '../../createIcon';

/**
 * @component @name Tsunami
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNjcgMTcuNjNDMTQuODcgMjAuNDMgMTIuNTUgMTguMDMgMTIgMTcuNjNDMTEuMzQgMTguMTIgOS4wOCAyMC4zOSA1LjMzIDE3LjYzQzMuNDMgMTkuMDMgMi42NSAxOSAyIDE5VjIxQzMuMTYgMjEgNC4zIDIwLjY4IDUuMzMgMjAuMDdDNy4zOSAyMS4yOSA5Ljk0IDIxLjI5IDEyIDIwLjA3QzE0LjA2IDIxLjI5IDE2LjYxIDIxLjI5IDE4LjY3IDIwLjA3QzE5LjcgMjAuNjggMjAuODQgMjEgMjIgMjFWMTlDMjEuMzQgMTkgMjAuNSAxOC45OCAxOC42NyAxNy42M1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOS4zMyAxMkgyMlYxMEgxOS4zM0MxNy41IDEwIDE2IDguNSAxNiA2LjY3QzE2IDUuNjUgMTYuMzggNC45MyAxNy4wOSAzLjMzQzE1LjcyIDMuMTIgMTUuMDkgMyAxNCAzQzcuMzYgMyAyLjE1IDguMDMgMi4wMSAxNC41TDIgMTYuNUMzLjE2IDE2LjUgNC4zIDE2LjE4IDUuMzMgMTUuNTdDNy4zOSAxNi43OSA5Ljk0IDE2Ljc5IDEyIDE1LjU3QzE0LjA2IDE2Ljc5IDE2LjYxIDE2Ljc5IDE4LjY3IDE1LjU3QzE5LjcgMTYuMTggMjAuODQgMTYuNSAyMiAxNi41VjE0LjVDMjEuMzQgMTQuNSAyMC41IDE0LjQ4IDE4LjY3IDEzLjEzQzE0Ljg3IDE1LjkzIDEyLjU1IDEzLjUzIDEyIDEzLjEzQzExLjEgMTMuOCAxMS40NiAxMy41NCAxMS4wOSAxMy43NkMxMC4zOSAxMi44MiAxMCAxMS43IDEwIDEwLjVDMTAgNy45MiAxMS43NyA1Ljc2IDE0LjIxIDUuMTdDMTQuMDggNS42OCAxNCA2LjE5IDE0IDYuNjdDMTQgOS42MSAxNi4zOSAxMiAxOS4zMyAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Tsunami = createIcon('Tsunami', [
  [
    'path',
    {
      d: 'M18.67 17.63C14.87 20.43 12.55 18.03 12 17.63C11.34 18.12 9.08 20.39 5.33 17.63C3.43 19.03 2.65 19 2 19V21C3.16 21 4.3 20.68 5.33 20.07C7.39 21.29 9.94 21.29 12 20.07C14.06 21.29 16.61 21.29 18.67 20.07C19.7 20.68 20.84 21 22 21V19C21.34 19 20.5 18.98 18.67 17.63Z',
      key: '19vrns',
    },
  ],
  [
    'path',
    {
      d: 'M19.33 12H22V10H19.33C17.5 10 16 8.5 16 6.67C16 5.65 16.38 4.93 17.09 3.33C15.72 3.12 15.09 3 14 3C7.36 3 2.15 8.03 2.01 14.5L2 16.5C3.16 16.5 4.3 16.18 5.33 15.57C7.39 16.79 9.94 16.79 12 15.57C14.06 16.79 16.61 16.79 18.67 15.57C19.7 16.18 20.84 16.5 22 16.5V14.5C21.34 14.5 20.5 14.48 18.67 13.13C14.87 15.93 12.55 13.53 12 13.13C11.1 13.8 11.46 13.54 11.09 13.76C10.39 12.82 10 11.7 10 10.5C10 7.92 11.77 5.76 14.21 5.17C14.08 5.68 14 6.19 14 6.67C14 9.61 16.39 12 19.33 12Z',
      key: 'cnpq0t',
    },
  ],
]);

export default Tsunami;
